import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* addLaborHours(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.ADD_LABOR_HOURS_LOADER });
    const response = yield call(laborHoursService.addLaborHour, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.ADD_LABOR_HOURS_SUCCESS,
        payload: { response: response.data, status: response?.status },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.ADD_LABOR_HOURS_FAILURE, payload: error });
  }
}

function* addLaborHoursSaga() {
  yield takeEvery(laborHoursConstant.ADD_LABOR_HOURS_REQUEST, addLaborHours);
}

export default addLaborHoursSaga;
